var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from '@aws-amplify/auth';
export class AxiosCognitoAuthorizationAdapter {
    constructor(axios) {
        this.axios = axios;
        this.originAdapter = this.axios.defaults.adapter;
        this.axios.defaults.adapter = this.adapter.bind(this);
    }
    adapter(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.token = yield Auth.currentSession().then((session) => session.getIdToken().getJwtToken());
            config.headers.Authorization = `Bearer ${this.token}`;
            return (_a = this.originAdapter) === null || _a === void 0 ? void 0 : _a.call(this, config);
        });
    }
}
//# sourceMappingURL=AxiosCognitoAuthorizationAdapter.js.map